import React from 'react'
import '../css/AboutUs.css'
import Navbar from './Navbar'

const ContactUs = () => {
  return (
    <div className='aboutuspage'>
      <Navbar />
      <div className="second_box_title_new">
        <span className="latest">CONTACT US</span> ━━━
      </div>

      <div className='actualaboutus'>
        <div className='contactinfous'>
          <div><strong>Location:</strong> 33-02, Jalan Austin Perdana 3/8, Taman Mount Austin 81100 JB</div>
          <div><strong>Tel:</strong> +65 9221 9241</div>
          <div><strong>Email:</strong> useblocbox@gmail.com</div>
          <div><strong>Telegram:</strong> <a href="https://t.me/UseBlocBox" target="_blank" rel="noopener noreferrer">Join our Telegram</a></div>
        </div>
      </div>
    </div>
  )
}

export default ContactUs